export function setLoginInfo(id) {
    const pa = getParams()
    sessionStorage.setItem(`loginInfo_invoiceV2_${pa.id}`, 'true')
}

export function removeLogin() {
    const pa = getParams()
    sessionStorage.removeItem(`loginInfo_invoiceV2_${pa.id}`)
}

export function isAlReadyLogin() {
    const pa = getParams()
    return Boolean(sessionStorage.getItem(`loginInfo_invoiceV2_${pa.id}`))
}

function getParams() {
    const pa = location.search.substr(1).split("&");
    const s = {}
    for (let i = 0; i < pa.length; i++) {
        s[pa[i].split("=")[0]] = decodeURIComponent(pa[i].split("=")[1]);
    }
    return s
}
